import React from 'react';
import { Toaster } from 'react-hot-toast';
import { ApolloProvider } from "@apollo/client";

import { client } from './src/apollo/client';
import Layout from './src/components/Layout';
import { CartProvider } from './src/contexts/CartContext';
import { AuthProvider } from './src/hooks/useAuth';
import { WishlistProvider } from './src/contexts/WishlistContext';
import { LoadingProvider } from './src/contexts/LoadingContext';

import './src/styles/reset.css';
import './src/styles/global.css';
import './src/styles/animations.css';
import './src/styles/slider.css';

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <LoadingProvider>
          {element}
          </LoadingProvider>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  </ApolloProvider>
)

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
    <Layout {...props}>
      {element}
      <Toaster />
    </Layout>
    </>
  )
}

// Listen for route updates
export const onPreRouteUpdate = () => {
  if (window.setLoading) {
    window.setLoading(true); // Show loader before navigation
  }
};

export const onRouteUpdate = () => {
  if (window.setLoading) {
    window.setLoading(false); // Hide loader after navigation
  }
};
